// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fade-enter-active[data-v-2bf29591],.fade-leave-active[data-v-2bf29591]{transition:opacity .2s ease}.fade-enter[data-v-2bf29591],.fade-leave-to[data-v-2bf29591]{opacity:0}.m-article-text-wide[data-v-2bf29591]{background:transparent;padding:30px 0;transition:background-color .2s ease-in-out,color .2s ease-in-out,border .2s ease-in-out}.m-article-text-wide__grid[data-v-2bf29591]{align-items:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
